/**
 * Отложенное присвоение бесплатного аудита.
 *
 * Зачем отдельное хранилище. Слаг аудита экран запуска кладёт в
 * `sessionStorage` — этого хватало, пока присвоение начиналось в той же
 * вкладке. Но путь от публичного отчёта до кабинета почти всегда рвёт вкладку
 * или историю:
 *
 *  - вход через Яндекс ID уводит на чужой домен и возвращается новой
 *    навигацией — состояние маршрута (`location.state.from`) до возврата не
 *    доживает;
 *  - регистрация заканчивается письмом, а ссылку из письма открывают когда
 *    угодно и обычно **в другой вкладке**, где `sessionStorage` пуст.
 *
 * В обоих случаях человек оказывался в кабинете без отчёта, а отчёт — ничьим.
 * Поэтому намерение «этот аудит забрать» живёт в `localStorage`: оно переживает
 * и вкладку, и возврат от провайдера.
 *
 * Здесь лежит **только слаг**, то есть публичный адрес отчёта, который и так
 * виден в строке браузера и пересылается ссылкой. Токен происхождения
 * (`X-Seeno-Audit-Session`), который и даёт право забрать отчёт, остаётся в
 * `sessionStorage`: это одноразовое доказательство, и переживать вкладку ему
 * незачем.
 */

const KEY = 'seeno.audit.claim';

/**
 * Запись в хранилище может отказать: приватный режим Safari и запрет
 * стороннего хранилища бросают исключение прямо из `setItem`. Присвоение от
 * этого не ломается — слаг едет ещё и в адресе, — поэтому отказ здесь молчит.
 */
export function rememberClaim(slug: string): void {
  if (!slug) return;
  try {
    localStorage.setItem(KEY, slug);
  } catch {
    /* хранилище недоступно — остаётся адрес */
  }
}

/** Слаг, который человек собирался забрать, если такой был. */
export function pendingClaim(): string | null {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

/** Забыть намерение: отчёт присвоен либо человек ушёл другим путём. */
export function forgetClaim(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* нечего забывать */
  }
}
